import { offlineloginSuccess, setOffline, isUserHasOfflineAccess, isEnableOfflineModeFeature } from "helper/OfflineHelper";
import { useEffect, useState } from "react";
import { useOfflineState } from "./commonHooks";
import { isSupportLogin } from "helper/commonHelpers";
import { getLocalStorage, setLocalStorage } from "utils";
import { LOCALSTORAGE_KEYS } from "utils/constants";
import { ToastNotifyError, ToastNotifySuccess } from "commonComponents/ToastNotify";
import moment from "moment";
import { fetchCommonData } from "redux-store/slices/common";
import { HEALTH_SERVICE_CHECK_INTERVAL, METHODS } from "data/constants";
import { isEmpty } from "lodash";
import { isSlave, isLocalServerEnable } from "helper/localServer";
import useSalesFlow from "./useSalesFlow";
import { useDispatch } from "react-redux";


export const useHealthStatusCheck = () => {        
   
  const [isSaleSyncing, setIsSaleSyncing] = useState(false);
  function closeSaleSyncModal() {
    setIsSaleSyncing(false);
  }
  const dispatch = useDispatch();
  const { isOffline, itemsData, channelDef, fetchDataFromDb, setFetchDataFromDb } = useOfflineState();
  const { isOrderFlowPath, hasOrderFlowLicense } = useSalesFlow();
  
  useEffect(() => {
      if (fetchDataFromDb && isOffline) {
        offlineloginSuccess();
        setFetchDataFromDb(false);
      }
  }, [fetchDataFromDb, isOffline]);
  
  function startOfflineMode() {
    if (isEmpty(itemsData) || isEmpty(channelDef)) {
      setFetchDataFromDb(true);
    }
    setOffline(true);
    setLocalStorage(LOCALSTORAGE_KEYS.isOffline, true);
  }
  
  function stopOfflineMode() {
    setLocalStorage(LOCALSTORAGE_KEYS.isOffline, false);
    setOffline(false);
    setIsSaleSyncing(true);
  }

  function healthServiceCallback(response : any){
    // Guard: Only process offline mode changes if following conditions are met
    // This follows the same pattern as AccountControl's offline toggle visibility
    const shouldAllowOfflineToggle = 
      !(isSlave() && isLocalServerEnable()) &&
      isEnableOfflineModeFeature() &&
      hasOrderFlowLicense &&
      isOrderFlowPath;

    if (!shouldAllowOfflineToggle) {
      return;
    }

    if(response) {
        const healthServiceVal = getLocalStorage(LOCALSTORAGE_KEYS.HEALTH_SERVICE_STATUS);
        if (response.status === 200 && healthServiceVal && JSON.parse(healthServiceVal)) {
            stopOfflineMode();
            ToastNotifySuccess('POS connection restored. Saved orders are syncing');
            setLocalStorage(LOCALSTORAGE_KEYS.HEALTH_SERVICE_STATUS, false);
        }
        else if(!isOffline && response.status === 540){ 
            ToastNotifyError('POS went offline due to connectivity issues. You can continue taking orders; they will sync automatically once restored.');
            setLocalStorage(LOCALSTORAGE_KEYS.HEALTH_SERVICE_STATUS, true);
            startOfflineMode();
        }
    }
  }

  useEffect(() => {
      if(isSupportLogin()){
        return;
      }
      
      const intervalId = setInterval( async () => {
        const url = process.env.REACT_APP_HEALTH_SERVICE_URL as string;
        const timestamp = moment.now();
        dispatch(
          fetchCommonData({
            method: METHODS.GET,
            url: `${url}?_dc=${timestamp}`,
            callback: healthServiceCallback,
            errorCallback: true,
            skipGlobalLoader: true
          })
        );
      }, HEALTH_SERVICE_CHECK_INTERVAL)

      return (() => clearInterval(intervalId));
  },[isOffline, hasOrderFlowLicense, isOrderFlowPath])

  return {
    isSaleSyncing,
    closeSaleSyncModal
  }
}